import { Module } from "vuex";
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import router from "@/router";
import { defaultFacilityValues } from "@/consts/defaultFacilityValues";
import { createFacilityFromBuddy } from "@/utils/buddyFacilityCreatorUtils";

const buddyModule: Module<any, any> = {
  namespaced: false,
  state: {
    currentRegions: null,
    selectedBuddyFacility: null,
    selectedBuddyFacilityUsers: [],
  },

  mutations: {
    setCurrentRegions(state: any, payload: []) {
      state.currentRegions = payload;
    },
    setSelectedBuddyFacility(state: any, payload: []) {
      state.selectedBuddyFacility = payload;
    },
    setSelectedFacilityUsers(state: any, payload: []) {
      state.selectedBuddyFacilityUsers = payload;
    },
    clearState(state: any) {
      state.currentRegions = null
      state.selectedBuddyFacility = null
      state.selectedBuddyFacilityUsers = [];
    },
  },

  actions: {
    async getBuddyFacilities({ commit }) {
      const facilities = firebase.firestore().collection("facility");
      return await facilities.get().then((querySnapshot) => {
        const facilitiesList: Array<any> = [];
        querySnapshot.docs.forEach((x) => {
          const thisRes = x.data();
          thisRes.id = x.id;
          facilitiesList.push(thisRes);
        });
        return facilitiesList
      });
    },

    async getBuddyOrgs({ commit }) {
      const organisations = firebase.firestore().collection("organisations");
      return await organisations.get().then((querySnapshot) => {
        const buddyOrganisationsList: Array<any> = [];
        querySnapshot.docs.forEach((x) => {
          const thisRes = x.data();
          thisRes.id = x.id;
          buddyOrganisationsList.push(thisRes);
        });
        return buddyOrganisationsList
      });
    },

    async getBuddyFacility({ commit }, id) {
      const fref = await firebase.firestore().collection("facility").doc(id).get();
      const careApiKey = await firebase.firestore().collection("facility").doc(id).collection("sensitive-data").where('type', '==', 'careApi').get()
      const facility = fref.data();
      console.log(careApiKey)
      facility.careApiKey = careApiKey?.docs[0]?.data().apiKey ?? '';
      facility.id = id;
      facility.dateFormat = facility.dateFormat || defaultFacilityValues.dateFormat
      facility.timeFormat = facility.timeFormat || defaultFacilityValues.timeFormat
      facility.languageIso = facility.languageIso || defaultFacilityValues.locale

      commit("setSelectedBuddyFacility", facility);
      return facility
    },

    async updateBuddyFacility({ dispatch, commit }, facility) {
      console.log("updating facility")
      const careApiKey = facility.careApiKey;
      facility.careApiKey = null;
      delete facility.dateTimeCreated
      await firebase
        .firestore()
        .collection("facility")
        .doc(facility.id)
        .update(facility)
        .then(async (Snap) =>  {
          await firebase
            .firestore()
            .collection("facility")
            .doc(facility.id)
            .collection("sensitive-data")
            .where('type', '==', 'careApi').get()
            .then(async (careapidoc) => {
              await firebase
                .firestore()
                .collection("facility")
                .doc(facility.id)
                .collection("sensitive-data")
                .doc(careapidoc.docs[0].id)
                .update({
                  apiKey: careApiKey
                })

            });

        });
    },

    async getBuddyFacilityUsers({ commit }, { id, orgId }) {

      const users = firebase.firestore().collection("users").where("orgId", "==", orgId);
      await users.get().then((querySnapshot) => {
        const usersList: Array<any> = [];
        querySnapshot.docs.forEach((x) => {

          
          const thisUsers = x.data();
          thisUsers.id = x.id;
          if (thisUsers.facilityId == id) {
            usersList.push(thisUsers);
          }
        });
        commit("setSelectedFacilityUsers", usersList);
      });
    },

    async getBuddyUsers({ commit }, id) {
      const users = firebase
        .firestore()
        .collection("users")
      await users.get().then((querySnapshot) => {
        const listUsers: Array<any> = [];

        querySnapshot.docs.forEach((x) => {
          const thisUser = x.data();
          thisUser.id = x.id;
          listUsers.push(thisUser);
        });
        commit("setUsers", listUsers);
      });
    },

    async getBuddyUser({ commit }, id) {
      const user = firebase
        .firestore()
        .collection("users")
        .doc(id);
      await user.get().then((querySnapshot) => {
        const currentUser = querySnapshot.data();
        if (currentUser != null) {
          currentUser.id = querySnapshot.id;
          commit("setUser", currentUser);
        }
      });
    },

    async createNewBuddyFacilityUser({ dispatch, commit }, { user, orgId }) {
      user.options = {
        webNotifications: {
          serviceRequestCreated: false,
          serviceRequestCompleted: false,
          unattendedEventEnded: false,
          maintenanceRequestCreated: false,
          deviceAssigned: false,
          deviceUnassigned: false,
          visitToResidentCreated: false,
          bookingsAndOrdersComment: false,
          messagesFromFamily: true,
        },
        emailNotifications: {
          serviceRequestCreated: false,
          serviceRequestCompleted: false,
          unattendedEventEnded: false,
          maintenanceRequestCreated: false,
          deviceAssigned: false,
          deviceUnassigned: false,
          visitToResidentCreated: false,
          bookingsAndOrdersComment: false,
          lifestyleEventsReport: false,
          messagesFromFamily: true,
        }
      }
      await firebase.firestore().collection("users").add(user).then((a) => { dispatch("getBuddyFacilityUsers", { facilityId: user.facilityId, orgId: user.orgId }) });
    },

    async createBuddyFacility({ dispatch, commit }, {facilityName, regionId, regionName, orgId, orgName, baseUrl, refId }) {
          const fid = await createFacilityFromBuddy(facilityName, regionId, regionName, orgId, orgName, baseUrl, refId )
      
          if (fid) {
            dispatch('getOrgUsers', orgId);
            dispatch('getFacilitiesForOrg', orgId);
            dispatch('getFacilityEmailTemplates', fid);
            await dispatch("getBuddyFacility", fid)
            router.push("/buddy/facilities/" + fid.toString());
          }
    },
     
    async createBuddyOrg({ dispatch, commit }, { name }) {
      await firebase.firestore().collection("organisations").add({ name: name, baseUrl: '' }).then((org) => {
        firebase.firestore().collection("regions").doc(org.id).set({ name: 'Default', orgId: org.id });
      })
    },

    async getBuddyRegions({ commit }, orgId) {

      const regions = firebase
        .firestore()
        .collection("regions")
        .where("orgId", "==", orgId)

      await regions.get().then((querySnapshot) => {
        const listRegions: Array<any> = [];

        querySnapshot.docs.forEach((x) => {
          const thisregion = x.data();
          thisregion.id = x.id;
          listRegions.push(thisregion);
        });
        commit("setCurrentRegions", listRegions);
      });
    },

    async clearBuddyState({ commit }) {
      commit("clearState");
    },
  },
};
export default buddyModule;

